import {
  GET_SCORE_CARD_RISK_FACTORS,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  getScoreCardRiskFactors,
  getScoreCardRiskFactorsPending,
  getScoreCardRiskFactorsFulfilled,
  getScoreCardRiskFactorsRejected,
} = createAsyncActions(GET_SCORE_CARD_RISK_FACTORS, 'getScoreCardRiskFactors');


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/getScoreCardRiskFactorsActions.js